import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useAppConfig } from "@/contexts/AppConfigContext";
import { Bell, ChevronDown } from "lucide-react";

const TITLES = {
  "/dashboard": "Dashboard",
  "/documents": "Documents",
  "/documents/upload": "Upload Document",
  "/schemas": "Document Schemas",
  "/webhooks": "Webhooks",
  "/api-keys": "API Keys",
  "/requests": "Document Requests",
  "/analytics": "Analytics",
  "/profile": "Profile",
  "/admin": "Super Admin",
  "/admin/companies": "Companies",
  "/admin/users": "Users",
  "/admin/config": "Configuration",
};

export default function Header() {
  const loc = useLocation();
  const { user } = useAuth();
  const { appName } = useAppConfig();

  const title = Object.keys(TITLES)
    .filter(k => loc.pathname === k || loc.pathname.startsWith(k + "/"))
    .sort((a, b) => b.length - a.length)[0];

  const roleLabel = user?.role === "superadmin" ? "Super Admin" : user?.role === "company_admin" ? "Admin" : "User";
  const initials = user?.full_name?.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2) || "?";

  return (
    <header className="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-6 flex-shrink-0">
      <h1 className="text-lg font-semibold text-slate-900">{TITLES[title] || appName}</h1>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#E5F0F2] flex items-center justify-center text-[#006080] text-xs font-bold">
            {initials}
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-slate-900 leading-tight">{user?.full_name}</p>
            <p className="text-xs text-slate-500">{roleLabel}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
